import { createAuthClient } from "@krix/auth/client";
import { useQuery } from "@tanstack/react-query";

const API_BASE = import.meta.env["VITE_API_BASE_URL"] ?? "http://localhost:3000";

export const authClient = createAuthClient({ baseURL: API_BASE });

interface SessionData {
  user: { id: string; email: string; name: string | null; role?: string };
  session: { id: string; userId: string };
}

export function useSession() {
  return useQuery<SessionData | null>({
    queryKey: ["admin-session"],
    queryFn: async () => {
      const res = await fetch(`${API_BASE}/api/auth/get-session`, { credentials: "include" });
      if (!res.ok || res.status === 204) return null;
      const text = await res.text();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch {
        return null;
      }
    },
  });
}

export function isStaff(role: string | undefined): boolean {
  if (!role) return false;
  const roles = role.split(",").map((r) => r.trim());
  return roles.some((r) => ["support", "content_manager", "admin", "superadmin"].includes(r));
}
